import {
  ChangeEvent, FocusEvent, KeyboardEvent, MutableRefObject, ReactElement,
} from 'react';
import { ValueProps, ValueSnapshot } from 'react-select-search';

// O tipo ValueProps exportado por react-select-search@3.0.10 não reflete o objeto
// que useSelect.js realmente devolve (faltam onFocus/onChange/ref, readOnly vem
// como "readonly"). Este tipo descreve o shape real em runtime.
interface SelectSearchValueDomProps {
  tabIndex: string;
  readOnly: boolean;
  disabled: boolean;
  ref: MutableRefObject<HTMLInputElement | null>;
  onFocus: () => void;
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
  onChange: ((event: ChangeEvent<HTMLInputElement>) => void) | null;
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
  onKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
  onKeyUp: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export function multiSelectRenderValue(domProps: ValueProps, snapshot: ValueSnapshot, className: string): ReactElement {
  const props = domProps as unknown as SelectSearchValueDomProps;
  const isShowingSummary = snapshot.search === '';

  // Enquanto o campo exibe o resumo da seleção (displayValue), o <input> real do
  // DOM contém esse texto. Sem isso, a 1ª tecla digitada é inserida no meio/fim
  // do resumo em vez de substituí-lo, e o onChange da lib captura a string
  // concatenada inteira como busca. Zerar o valor no keydown, antes da inserção
  // nativa do caractere, faz a digitação começar de um campo vazio.
  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (isShowingSummary && (event.key.length === 1 || event.key === 'Backspace' || event.key === 'Delete')) {
      event.currentTarget.value = '';
    }
    props.onKeyDown(event);
  };

  return (
    <input
      ref={props.ref}
      tabIndex={Number(props.tabIndex)}
      readOnly={props.readOnly}
      disabled={props.disabled}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onChange={props.onChange ?? undefined}
      onKeyDown={onKeyDown}
      onKeyPress={props.onKeyPress}
      onKeyUp={props.onKeyUp}
      className={className}
      value={snapshot.search !== '' ? snapshot.search : snapshot.displayValue}
    />
  );
}
